import CardContent from '@mui/material/CardContent';

export { CardContent };
